import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // updateViaCache:'none' prevents the browser from HTTP-caching the SW file
    // itself — critical so a fresh service-worker.js is always fetched.
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then((reg) => {
        // Belt-and-braces: force an immediate update check on every page load
        // so stale bundles from an old cache-first SW don't stick around.
        reg.update().catch(() => {});
        // Force one-shot reload the first time a new SW takes control so users
        // get the newest bundle right after a deploy instead of a stale one.
        let reloaded = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
        reg.addEventListener('updatefound', () => {
          const worker = reg.installing;
          if (worker) worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              worker.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch((err) => console.log('SW registration failed:', err));
  });
}
